import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import styles from "./OneCertificat.module.scss";
import {
  GreenLedSolo,
  BlueLedSolo,
  RedLedSolo,
  YellowLedSolo,
} from "../Team/userCard/Led";

import Select from "react-select";
import { MdOutlineMail } from "react-icons/md";
import Button from "../UiComponents/Button";
import { IoMdPersonAdd } from "react-icons/io";
import { CgSelectR } from "react-icons/cg";
import Modal from "../UiComponents/modals/Modal";
import useModal from "../../hooks/useModal";
import { toast } from "react-toastify";
import Axios from "../../_services/caller.service";
import { PermissionGate } from "../superAdmin/managePermissions/PermissionGate";

const OneCertificat = ({
  cabname,
  sendCertifByMail,
  cab,
  users,
  setUserToSendEmail,
  email,
  setLoadingCabineUser
}) => {
  const [enterEmailInInput, setEnterEmailInInput] = useState(false);
  const [cabineUsers, setCabineUsers] = useState([]);
  const [hoveredType, setHoveredType] = useState(null);
  const { t } = useTranslation();

  const { isShowing, toggle } = useModal();

  const displayGoodColorLed = (number, label) => {
    if (number <= 0 && number !== null)
      return <RedLedSolo label={label} />;
    else if (number <= 90 && number !== null)
      return <YellowLedSolo label={label} />;
    else if (number >= 90 && number !== null)
      return <GreenLedSolo label={label} />;
    else if (number == null || undefined)
      return <BlueLedSolo label={label} />;
  };

  // LOGIQUE DE CHOIX POUR ENVOIE DU CERTICAT PAR MAIL
  const handleChange = (e) => {
    setUserToSendEmail(e.target.value);
  };


  const openModal = () => {

    if (email === undefined) {
      toast.error(t("calibration.enter_email"));
      return;
    }
    toggle();
  };

  // VERIFY IF USER IS AUTH FOR THIS CABINE
  useEffect(() => {
    Axios.get(`/getCabineUser/${cab.id}`)
      .then((response) => {
        setLoadingCabineUser(false)
        // Vérifiez si les données sont présentes
        if (response.data && response.data.data) {
          const options = response.data.data.map((user) => ({
            value: user.user_email,
            label: `${user.user_login} - ${user.user_email} - ${user.ID}`,
          }));
          setCabineUsers(options);
        } else {
          // Gérer le cas où il n'y a pas de données
          setCabineUsers([]);
          // Vous pouvez également afficher un message à l'utilisateur si nécessaire
        }
      })
      .catch((error) => {
        console.error("Erreur lors de la récupération des données : ", error);
        // Gérer les autres types d'erreurs ici
      });
  }, []); // Dépendance à cab.id

  const renderLedCell = (days, label, type) => (
    <td
      className={styles.tdLed}
      onMouseEnter={() => setHoveredType(type)}
      onMouseLeave={() => setHoveredType(null)}
    >
      {days !== null && days !== undefined ? (
        <div className={styles.ledWrapper}>
          {displayGoodColorLed(days, label)}
          {hoveredType === type && (
            <div className={styles.tooltip}>
              <strong>{Math.abs(days)}</strong>
              <span>{days >= 0 ? t("calibration.d_remaining") : t("calibration.d_overdue")}</span>
            </div>
          )}
        </div>
      ) : (
        <span className={styles.noData}>—</span>
      )}
    </td>
  );

  return (
    <>
      <tr className={styles.tr}>
        <td className={styles.td}>{cabname}</td>
        {renderLedCell(cab.numberDayBone, "CO", "co")}
        {renderLedCell(cab.numberDayHead, "Casque", "head")}
        {renderLedCell(cab.numberDayInsert, "Insert", "insert")}
        {renderLedCell(cab.numberDaySpeakers, "CL", "speakers")}
        <td className={styles.tdSelect}>
          {!enterEmailInInput ? (
            <div className={styles.selectRow}>
              <Select
                options={cabineUsers}
                className={styles.selectUser}
                placeholder={t("calibration.select_placeholder")}
                onChange={(selectedOption) =>
                  handleChange({ target: { value: selectedOption.value } })
                }
              />
              <IoMdPersonAdd
                className={`${styles.iconToggle} has-tooltip`}
                aria-label={t("calibration.enter_email_manual")}
                onClick={() => setEnterEmailInInput(true)}
              />
            </div>
          ) : (
            <div className={styles.selectRow}>
              <input
                type="email"
                className={styles.emailInput}
                placeholder="Email"
                onChange={(e) => setUserToSendEmail(e.target.value)}
              />
              <CgSelectR
                className={`${styles.iconToggle} has-tooltip`}
                aria-label={t("calibration.choose_user")}
                onClick={() => setEnterEmailInInput(false)}
              />
            </div>
          )}
        </td>
        <td className={styles.tdActions}>
          <PermissionGate actionKey={"manageCertificat.sendCertificatEmail"}>
            <button className={styles.btnSend} onClick={openModal} type="button">
              <MdOutlineMail /> {t("calibration.send")}
            </button>
          </PermissionGate>
        </td>
      </tr>
      <Modal isShowing={isShowing} hide={toggle}>
        <div className={styles.containerModal}>
          <h2>{t("calibration.send_certificate_title")}</h2>
          <p>Cabine : <strong>{cabname}</strong></p>
          <p>Pour : <strong>{email}</strong></p>
          <Button
            onPress={sendCertifByMail}
            styles={"btnValidation"}
            text={t("calibration.confirm_send")}
            svg={<MdOutlineMail />}
          />
        </div>
      </Modal>
    </>
  );
};

export default OneCertificat;
